/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component, FormEvent } from 'react';
import { connect } from 'react-redux';
import { convertToRaw, Modifier, EditorState, RichUtils } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import ReactTooltip from 'react-tooltip';

import handleKeyPress from '../../../../../../../../common/handleKeyPress';
import BananatagButton from '../../../../../../../../componentLibrary/BananatagButton';
import InputValidator from '../../../../../../../../componentLibrary/InputValidator';
import Input from '../../../../../../../../componentLibrary/Input';
import { getLinkTarget, getSelectionText } from './HelperMethods/draftUtils';
import * as columnItemActions from '../../../../../../../../actions/columnItem';
import imageSources from '../../../../../../../../constants/imageSources/imageSources';
import { IBlock } from '../../../../../../../../types/content';
import { hexToRGB } from '../../../../../../../../common/colorUtils';
import * as Styled from './styles';

const ValidatedLink = InputValidator(Input, { url: 1 });

interface IProps {
    editorState: EditorState;
    dispatch: (arg: any) => void;
    canvasBlocks: IBlock[];
    selectedElements: {
        [elmIdx: string]: {
            blockIndex: string;
            columnIdx: string;
            type: string;
            width: number;
        };
    };
    session: any;
}

class Link extends Component<IProps> {
    state = {
        showModal: false,
        linkTitle: '',
        linkTarget: '',
        linkTargetOption: '_blank', // for emails it is always blank
    };

    modalHandler = () => {
        const { editorState } = this.props;
        const selectionText = getSelectionText(editorState);
        const linkTarget = getLinkTarget(editorState);

        this.setState((prevState: any) => ({
            showModal: !prevState.showModal,
            linkTitle: selectionText,
            linkTarget,
        }));
    };

    hideModal = () => {
        this.setState({ showModal: false });
    };

    updateTitle = (event: FormEvent<HTMLInputElement>) => {
        this.setState({ linkTitle: event.currentTarget.value });
    };

    updateTarget = (event: FormEvent<HTMLInputElement>) => {
        this.setState({ linkTarget: event.currentTarget.value });
    };

    getContent = () => {
        const { canvasBlocks, selectedElements } = this.props;
        const elmIdx = Object.keys(selectedElements)[0];
        const { blockIndex, columnIdx } = selectedElements[elmIdx];
        const column = canvasBlocks
            .filter((block) => block.index === blockIndex)[0]
            .content.columns.filter((c) => c.columnIdx === columnIdx)[0];
        const { content } = column.columnItems.filter((el) => el.elmIdx === elmIdx)[0];
        return { blockIndex, columnIdx, content, elmIdx };
    };

    addLink = () => {
        const {
            editorState,
            dispatch,
            session: { user },
        } = this.props;
        const {
            customization: { linkColor, linkDecoration },
        } = user;
        const { linkTarget, linkTargetOption, linkTitle } = this.state;
        const { blockIndex, columnIdx, content, elmIdx } = this.getContent();

        const contentState = editorState.getCurrentContent();
        const contentStateWithEntity = contentState.createEntity('LINK', 'MUTABLE', {
            url: linkTarget,
            targetOption: linkTargetOption,
        });
        const entityKey = contentStateWithEntity.getLastCreatedEntityKey();

        const selection = editorState.getSelection();
        const newInlineStyle = editorState.getCurrentInlineStyle().add(`color-${linkColor}`).add(linkDecoration);
        const newContentState = Modifier.replaceText(contentState, selection, linkTitle, newInlineStyle, entityKey);
        const newEditorState = EditorState.push(editorState, newContentState, 'insert-characters');

        const newMarkupString = draftToHtml(
            convertToRaw(RichUtils.toggleLink(newEditorState, selection, entityKey).getCurrentContent())
        );
        const newContent = {
            ...content,
            textMarkupValue: newMarkupString,
        };

        dispatch(columnItemActions.updateColumnItemContent({ blockIndex, columnIdx, elmIdx, newContent }));
        this.hideModal();
    };

    removeLink = () => {
        const {
            editorState,
            dispatch,
            session: { user },
        } = this.props;
        const {
            customization: { linkColor, linkDecoration },
        } = user;
        const { blockIndex, columnIdx, content, elmIdx } = this.getContent();

        const selection = editorState.getSelection();
        if (!selection.isCollapsed()) {
            let contentState = RichUtils.toggleLink(editorState, selection, null).getCurrentContent();
            contentState = Modifier.removeInlineStyle(
                contentState,
                selection,
                `color-${hexToRGB(linkColor).stringValue}`
            );
            contentState = Modifier.removeInlineStyle(contentState, selection, linkDecoration);

            const newMarkupString = draftToHtml(convertToRaw(contentState));
            const newContent = {
                ...content,
                textMarkupValue: newMarkupString,
            };

            dispatch(columnItemActions.updateColumnItemContent({ blockIndex, columnIdx, elmIdx, newContent }));
            this.hideModal();
        }
    };

    _renderModal = () => {
        const { linkTitle, linkTarget } = this.state;
        return (
            <Styled.LinkModalDiv>
                <Styled.LinkModalLabel htmlFor="linkTarget">LINK</Styled.LinkModalLabel>
                {/* @ts-ignore TODO: Type InputValidator */}
                <ValidatedLink
                    customIcon={imageSources.ICONS.LINK}
                    id="linkTarget"
                    onBlur={this.updateTarget}
                    onChange={this.updateTarget}
                    placeholder="Enter link URL here"
                    type="text"
                    value={linkTarget}
                    width="100%"
                />
                <Styled.LinkModalLabel htmlFor="linkTitle" style={{ marginTop: 6 }}>
                    LINK TEXT
                </Styled.LinkModalLabel>
                {/* @ts-ignore TODO: Type InputValidator */}
                <Input
                    customIcon={imageSources.ICONS.LINK_TEXT}
                    id="linkTitle"
                    onBlur={this.updateTitle}
                    onChange={this.updateTitle}
                    type="text"
                    value={linkTitle}
                    width="100%"
                />
                <Styled.LinkButtonsDiv>
                    <BananatagButton
                        text="remove"
                        onClick={this.removeLink}
                        size="small"
                        styling={{ marginRight: 8 }}
                        type="clear"
                    />
                    <BananatagButton
                        disabled={!linkTarget || !linkTitle}
                        onClick={this.addLink}
                        icon="add"
                        size="small"
                        text="add link"
                    />
                </Styled.LinkButtonsDiv>
            </Styled.LinkModalDiv>
        );
    };

    render() {
        const { showModal } = this.state;
        return (
            <>
                <Styled.LinkMenuButtonDiv
                    className="rdw-option-wrapper draftButton borderLeft"
                    onClick={() => this.modalHandler()}
                    onKeyDown={(e) => handleKeyPress(e, () => this.modalHandler())}
                >
                    <Styled.LinkMenuButtonIconDiv data-tip data-for="textInsertLink">
                        <img src={imageSources.ICONS.LINK} alt="Link Icon" />
                    </Styled.LinkMenuButtonIconDiv>
                    <ReactTooltip id="textInsertLink" place="top" effect="solid">
                        <Styled.MenuButtonIconTooltipText>Insert Link</Styled.MenuButtonIconTooltipText>
                    </ReactTooltip>
                </Styled.LinkMenuButtonDiv>

                {showModal ? this._renderModal() : null}
            </>
        );
    }
}

const mapStateToProps = (state: any) => ({
    canvasBlocks: state.canvasBlocks.present,
    selectedElements: state.selectedElements.local,
    session: state.session,
});

export default connect(mapStateToProps)(Link);
